import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SprekerService } from '../spreker.service';

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.css']
})
export class ExploreComponent implements OnInit {

  sprekers;
  deg = 0; // the amount of degrees the planet is currently rotated

  constructor(public router: Router, private sprekerService: SprekerService) {
    this.sprekers = sprekerService.getSprekers();
    console.log(this.sprekers);
  }

  ngOnInit(){
    this.rotate(0); // this is to make sure you don't get scrollbalks when first loading the explore page
  }

  rotate(direction: number) {
      // rotate function inspired by https://stackoverflow.com/questions/19126432/rotate-a-div-using-javascript
      // (but changed for my purposes)
      this.deg += 60 * direction;

      let div = document.getElementById('rotatingPlanet'); 
      div.style.transform = 'rotate(' + this.deg + 'deg)';

  }

}
